var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReported(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.8,45.7v1c0,1.2-0.9,2.1-2.1,2.1h0H4.1c-1.2,0-2.1-0.9-2.1-2.1l0,0v-1c0-2.5,3-4.1,5.7-5.3 c0.1,0,0.2-0.1,0.3-0.2c0.2-0.1,0.5-0.1,0.7,0c1.1,0.7,2.4,1.1,3.8,1.1c1.3,0,2.6-0.4,3.8-1.1c0.2-0.1,0.4-0.1,0.6,0 c0.1,0,0.2,0.1,0.3,0.2C19.9,41.7,22.8,43.2,22.8,45.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4,
    cy: 33.7,
    rx: 5.2,
    ry: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8,3.2L34.8,3.2c-8.5,0-15.3,6.5-15.3,14.5c0,2.5,0.7,5,2,7.2c0.1,0.2,0.2,0.5,0.2,0.8L20,30.3 c-0.2,0.6,0.2,1.1,0.7,1.3c0.2,0.1,0.4,0.1,0.6,0l4.5-1.6c0.3-0.1,0.6-0.1,0.8,0.1c2.4,1.4,5.2,2.2,8,2.2c8.5,0,15.3-6.6,15.3-14.6 C50,9.7,43.1,3.2,34.8,3.2z M33.7,8.9h3v7l-0.3,4.6H34l-0.2-4.6V8.9z M35.2,26.2c-1.4,0-1.8-0.8-1.8-1.8c0-1,0.4-1.8,1.8-1.8 c1.4,0,1.8,0.8,1.8,1.8C37.1,25.4,36.6,26.2,35.2,26.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReported);
export default __webpack_public_path__ + "static/media/reported.40d3d5aa430ccf9ad7c480bea6ad3ce2.svg";
export { ForwardRef as ReactComponent };